import type { I18nPrefix } from '../../i18n/prefix';

export const I18N_MOBILE_HEADER = 'features:app.components.mobile_header' satisfies I18nPrefix;
